//GeneratorFlag:[NoChange]
import FeatureGroup from './feature-group';
import FeatureGroupFilter from './feature-group-filter';

export default {FeatureGroup, FeatureGroupFilter}
export{FeatureGroup, FeatureGroupFilter}